import { AdTypes, storeCachedAds, getCachedAds } from "@shared/services/cached_ads";
import { HttpPromise } from "@shared/svelte/Modules/ApiService";

export const getShoppableUnits = async (
  pageName: string,
  pageValue: string = undefined,
  params: any = {},
) => {
  const options = {
    page_name: pageName,
    page_value: pageValue,
    page: params.page,
    ...params,
  };

  let shoppableUnitConfig = [];
  if (params.page && parseInt(params.page) > 1) {
    shoppableUnitConfig = getCachedAds(AdTypes.ShoppableUnit, params, 1);

    if (shoppableUnitConfig.length > 0) {
      return shoppableUnitConfig[0];
    }
  } else {
    try {
      const res = await HttpPromise({
        method: "GET",
        url: "/api/retailer/shoppable_unit/shoppable_unit_placements",
        data: options,
      });

      if (res.length > 0) {
        storeCachedAds(AdTypes.ShoppableUnit, res, params);
      }
      shoppableUnitConfig = getCachedAds(AdTypes.ShoppableUnit, params, 1);
      return shoppableUnitConfig[0];
    } catch (e) {
      return shoppableUnitConfig;
    }
  }
};
